export const constants = {
  targetZone: {
    title: "Trainers",
    addButtonTitle: "Add Trainer",
    noRecordsMatch: "No matches found. Please try another search.",
    noRecords: "No trainers added yet.",
  },
  details: {
    title: "Trainer Details",
    backButton: " Back to Trainers",
  },
};
